import vue from 'vue';

export default function buildPayLogStore(store){
    store.actions.correction = async (context, payload) => await vue.prototype.$myHttp.post('/api/PayLogs/Correction', payload);
    store.actions.clientToClient = async (context, payload) => await vue.prototype.$myHttp.post('/api/PayLogs/clientToClient', payload);
    store.actions.rejectCorrection = async (context, payload) => await vue.prototype.$myHttp.post('/api/PayLogs/rejectCorrection', payload);
    return store;
}